/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const deletePipeline = `mutation DeletePipeline($customer_id: String!, $id: String!) {
    deletePipeline(customer_id: $customer_id, id: $id)
  }
  `;
